import { Component, HostBinding, OnDestroy, OnInit, Pipe, PipeTransform } from '@angular/core';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../core/services/logger.service';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';
import { FacultyService } from 'src/app/services/faculty.service';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { trigger, transition, style, animate } from '@angular/animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { ProfileService } from 'src/app/core/services/profile.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { CourseCatalogService } from '../../services/course-catalog.service';
import { SyllabusUpdateModalComponent } from './syllabus-update-modal/syllabus-update-modal.component';
import { FacultyRoleFilterPipe } from '../../shared/faculty.pipe';

@Component({
    selector: 'faculty-courses',
    templateUrl: './faculty-courses.component.html',
    styleUrls: ['./faculty-courses.component.scss'],
    animations: [
        trigger('classesLoadTrigger', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('1000ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('1000ms', style({ opacity: 0 }))
            ])
        ]),
    ],
    standalone: false
})

export class FacultyCoursesComponent implements OnInit, OnDestroy, IWidgetComponent {
    public data: Widget;
   
    active = 1; //default selected tab (academics)
        
    isCollapsed: boolean[] = [true];
    today = this.utility.getCurrentDate().toISOString();
  
    public classesSubj$: Subject<any> = new Subject<any>();
    
    @HostBinding('class')
    get size(): string {
        var widgetSize = 'col-md-' + this.data.Size.toString();

        switch (this.data.Size) {
            case 4: {
                widgetSize += ' widget-small';
                break;
            }
            case 6: {
                widgetSize += ' widget-medium';
                break;
            }
            case 12: {
                widgetSize += ' widget-large';
                break;
            }
        }

        return widgetSize;
    }
          
    public sectionCount$: Observable<number> = this.facultyService.classes$.pipe(
        map((data) => {
            var count = 0;
            data.sectionsByGroup.forEach(g => { count += g.Sections.length });
            return count;
        })
    ); 

    public totals$: Observable<any> = this.facultyService.classes$.pipe(
        map((data) => {
            var earned = 0;
            var base = 0;
            var addtl = 0;
            var bank = 0;
            data.sectionsByGroup.forEach(g => {
                g.Sections.forEach(s => {
                    if (s.TeachingCreditsData) {                        
                        earned += Number(s.TeachingCreditsData.Earned.toFixed(3));
                        base += Number(s.TeachingCreditsData.Inloaded.toFixed(3));
                        addtl += Number(s.TeachingCreditsData.Outloaded.toFixed(3));
                        bank += Number(s.TeachingCreditsData.Banked.toFixed(3));
                    }
                })
            });
            return { earned, base, addtl, bank };
        })
    ); 

    constructor(        
        private logger: LoggerService,
        public facultyService: FacultyService,
        public auth: AuthenticationService,
        private rolePipe: FacultyRoleFilterPipe,
        public profileService: ProfileService,
        private utility: UtilityService,       
        public catalog: CourseCatalogService,
        private modalService: NgbModal,

    ) {
        this.log("constructor", null, LogCategory.Constructor);       
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.FacultyCourses, category);
    }
    
    ngOnInit() {
        this.log("ngOnInit", null, LogCategory.Init);       
    }

    ngOnDestroy() {     
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }

    collapse(key) {
        var showKey = this.rolePipe.transform(key);
        if (showKey)            
            return !this.isCollapsed[key]
        
        return false;
    }

    fetchClasses(type) {
        this.facultyService.classesEndPoint = type;
        this.facultyService.pageNumber$.next(0);
    }       
  

    updateSyllabus(section) {        
        const modalRef = this.modalService.open(SyllabusUpdateModalComponent, {size: 'lg'});     
        modalRef.componentInstance.section = section;
    }

    public dateIsSameOrAfterToday(stringDate) {
        var endDateZeroTime = (new Date(stringDate)).setHours(0, 0, 0, 0);
        var todayZeroTime = (new Date(this.today)).setHours(0, 0, 0, 0);
        return endDateZeroTime.valueOf() >= todayZeroTime.valueOf();
    }

    public approve(year) {
        this.facultyService.approveYear$.next(year);

    }
}
